export enum Indicator {
  up = 'up',
  down = 'down',
}
